import { InfoContainer } from './styles';

export default function PersonInfos({ verticalCenter, infoComponents }) {
  return <InfoContainer verticalCenter={verticalCenter}>{infoComponents}</InfoContainer>;
}
